import { render, staticRenderFns } from "./selfSignList.vue?vue&type=template&id=0c2675fe"
import script from "./selfSignList.vue?vue&type=script&lang=js"
export * from "./selfSignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports